import './App.css';



import choose_image1 from "../src/assets/images/choose/choose-image1.jpg"
import growth_shape from "../src/assets/images/shape/growth-shape.png"
import dual_circle from "../src/assets/images/shape/dual-circle.png"
import case_image1 from "../src/assets/images/case/case-image1.jpg"
import case_image2 from "../src/assets/images/case/case-image2.jpg"
import case_image3 from "../src/assets/images/case/case-image3.jpg"
import case_image4 from "../src/assets/images/case/case-image4.jpg"
import stategy_globe from "../src/assets/images/shape/stategy-globe.png"
import strategy_image from "../src/assets/images/strategy/strategy-image.jpg"
import strategy_info from "../src/assets/images/strategy/strategy-info.png"
import team_shape from "../src/assets/images/shape/team-shape.png"
import team_image1 from "../src/assets/images/team/team-image1.jpg"
import team_image2 from "../src/assets/images/team/team-image2.jpg"
import team_image3 from "../src/assets/images/team/team-image3.jpg"
import team_image4 from "../src/assets/images/team/team-image4.jpg"
import faq_image1 from "../src/assets/images/faq/faq-image1.jpg"
import faq_map from "../src/assets/images/shape/faq-map.png"
import testimonial_shape from "../src/assets/images/shape/testimonial-shape.png"
import testimonial_image1 from "../src/assets/images/testimonial/testimonial-image1.jpg"
import testimonial_image2 from "../src/assets/images/testimonial/testimonial-image2.jpg"
import blog_image1 from "../src/assets/images/blog/blog-image1.jpg"
import blog_image2 from "../src/assets/images/blog/blog-image2.jpg"
import blog_image3 from "../src/assets/images/blog/blog-image3.jpg"

import { useEffect } from 'react';
import Banner from './pages/home/components/Banner';
import Header from './components/Header';
import Footer from './components/Footer';
import { useInitTemplate } from './hooks/useInitTemplate';
import AboutSection from './pages/home/components/AboutSection';
import ServiceSection from './pages/home/components/ServiceSection';
import AppRoutes from './routes/AppRoutes';
import { BrowserRouter } from 'react-router-dom';
import "./utils/extensions"

function App() {

  return (
    <BrowserRouter>
      <AppRoutes />
    </BrowserRouter>
  );
}

export default App;
